import { Box } from "@mui/material"
import { TemplateModal } from "./TemplateModal"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { ProductData, TemplateData } from "../../types";
import { useAuth } from "../../assets/contexts/AuthContext";
import { useAPI } from "../../hooks/useAPI";

interface EditTemplateProps {
  products: ProductData[];
  refetchTemplates: () => void;
}

export const EditTemplate = ({ refetchTemplates, products }: EditTemplateProps) => {
  const { template_id } = useParams();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const isLoading = useRef(false);
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const [template, setTemplate] = useState<TemplateData>({});

  const handleClose = () => {
    setOpen(false);
    navigate('/templates');
  }

  const handleSave = () => {
    navigate('/templates');
    refetchTemplates();
  }
  
  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      isLoading.current = true;

      fetchData(`/templates/${template_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setTemplate(data);
        setOpen(true);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })
    }
  }, [isAuthenticated, template_id]);

  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="edit-product">
      <TemplateModal 
        open={open} 
        handleClose={handleClose}
        handleSave={handleSave}
        products={products} 
        template={template}
      />
    </Box>
  )
}